// Componente per sistema ExeDialog. Salva i dati con una mutation
import React from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import { useNavigate, useLocation } from 'react-router-dom';

const GQL_CONTATORI = gql`
query AltriContatori($up_matricola: String!) {
    costi2009_contatore(where: {up_matricola: {_eq: $up_matricola}}, order_by: {cnt_matricola: asc}) {
        cnt_matricola
        cnt_descrizione
        note
    }
}
`

const GQL_MUTATION = gql`
mutation AddVoce($up_matricola: String!, $cnt_matricola: String!, $data: timestamptz!, $cfonte: String!, $ccosto: String!, $quantita: numeric!) {
    result: insert_costi2009_registro(objects: {up_matricola: $up_matricola, cnt_matricola: $cnt_matricola, data: $data, cfonte: $cfonte, ccosto: $ccosto, quantita: $quantita}) {
        affected_rows
    }
}
`
export function AddVoceSave(props) {
    const navigate = useNavigate()
    const location = useLocation()
    const {currURLSearchParams} = props;
    const up_matricola = currURLSearchParams.get('up_matricola');
    const cnt_matricola = currURLSearchParams.get('cnt_matricola');
    const [addVoce, { loading, error, data }] = useMutation(GQL_MUTATION);
    const { data: dataContatori } = useQuery(GQL_CONTATORI, { variables: { up_matricola } });
    if (loading) return 'Loading...';
    if (error) return (
        <div className="card-body">
            <h5 className="card-title">Errore</h5>
            {error?.graphQLErrors[0].extensions?.code === "constraint-violation" ? "Dati già presenti per il contatore a quell'ora" : error.message}
        </div>
        )
    if (data?.result) return (
        <div className="card-body">
            <h5 className="card-title">Dati salvati con successo</h5>
            <dl className="row">
                <dt className="col-sm-4">Unità produttiva</dt>
                <dd className="col-sm-8">{up_matricola}</dd>
                <dt className="col-sm-4">Contatore</dt>
                <dd className="col-sm-8">{cnt_matricola}</dd>
                <dt className="col-sm-4">Data</dt>
                <dd className="col-sm-8">{new Date(currURLSearchParams.get('data')).toLocaleString()}</dd>
                <dt className="col-sm-4">Centro di prelievo</dt>
                <dd className="col-sm-8">{currURLSearchParams.get('cfonte')}</dd>
                <dt className="col-sm-4">Centro di costo</dt>
                <dd className="col-sm-8">{currURLSearchParams.get('ccosto')}</dd>
                <dt className="col-sm-4">Quantità</dt>
                <dd className="col-sm-8">{currURLSearchParams.get('quantita')}</dd>
            </dl>
            <h6>Per la stessa macchina e con la stessa data si puo' inserire il valore dei seguenti contatori:</h6>
            <table className="table table-sm table-striped">
                <thead>
                    <tr>
                        <th>Contatore</th>
                        <th>Descrizione</th>
                        <th>Note</th>
                    </tr>
                </thead>
                <tbody>
                    {(dataContatori?.costi2009_contatore || []).filter(c => c.cnt_matricola !== cnt_matricola).map(c => {
                        const params = new URLSearchParams(currURLSearchParams);
                        params.set('cnt_matricola', c.cnt_matricola);
                        params.delete('quantita');
                        return (
                            <tr key={c.cnt_matricola}>
                                <td><a href={'#' + location.pathname + '?' + params.toString()}>{c.cnt_matricola}</a></td>
                                <td>{c.cnt_descrizione}</td>
                                <td>{c.note}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <button className="btn btn-primary" onClick={() => navigate('/c2009registro')}>Chiudi</button>
        </div>
    )
    const save = async () => {
        try {
            await addVoce({
                variables: {
                    up_matricola,
                    cnt_matricola,
                    data: currURLSearchParams.get('data'),
                    cfonte: currURLSearchParams.get('cfonte'),
                    ccosto: currURLSearchParams.get('ccosto'),
                    quantita: currURLSearchParams.get('quantita')}
                })
        } catch (e) {
            console.log(e)
        }
    }
    return (
        <div className="card-body">
            <h5 className="card-title">Dati da salvare (per modificare torna indietro alle pagine precedenti)</h5>
            <form onSubmit={ e => {e.preventDefault(); save()}}>
                <div className="mb-3">
                    <label htmlFor="up_matricola" className="form-label">Unità produttiva</label>
                    <input type="text" readOnly className="form-control" id="up_matricola" value={up_matricola} />
                </div>
                <div className="mb-3">
                    <label htmlFor="cnt_matricola" className="form-label">Contatore</label>
                    <input type="text" readOnly className="form-control" id="cnt_matricola" value={cnt_matricola} />
                </div>
                <div className="mb-3">
                    <label htmlFor="data" className="form-label">Data</label>
                    <input type="text" readOnly className="form-control" id="data" value={(new Date(currURLSearchParams.get('data'))).toLocaleString()} />
                </div>
                <div className="mb-3">
                    <label htmlFor="cfonte" className="form-label">Centro di prelievo</label>
                    <input type="text" readOnly className="form-control" id="cfonte" value={currURLSearchParams.get('cfonte')} />
                </div>
                <div className="mb-3">
                    <label htmlFor="ccosto" className="form-label">Centro di costo</label>
                    <input type="text" readOnly className="form-control" id="ccosto" value={currURLSearchParams.get('ccosto')} />
                </div>
                <div className="mb-3">
                    <label htmlFor="quantita" className="form-label">Quantità</label>
                    <input type="text" readOnly className="form-control" id="quantita" value={currURLSearchParams.get('quantita')} />
                </div>
                <button className="btn btn-primary">Salva</button>
            </form>
        </div>
    )
}

AddVoceSave.displayName = 'AddVoceSave';